var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showError } from 'store/commonReducer/common.action';
import { getTaskListService, getTaskStatsService, getUsersByRoleService, } from './services/taskManagement.service';
import { API_RESPONSE_REPORT_TYPES } from 'globals/enums';
import { getReportService, postReportService, } from 'services/reportsService/reportsService';
import moment from 'moment';
import { showApplicationLoader } from 'common/ApplicationLoader';
export var GET_TASK_LIST = 'GET_TASK_LIST';
export var SET_TASK_LIST = 'SET_TASK_LIST';
export var GET_TASK_LOADING = 'GET_TASK_LOADING';
export var SET_TASK_STATS = 'SET_TASK_STATS';
export var SET_TASK_FILTERS = 'SET_TASK_FILTERS';
export var RESET_TASK_MANAGEMENT = 'RESET_TASK_MANAGEMENT';
export var GET_TASK_STATS = 'GET_TASK_STATS';
export var SET_TASK_ERROR = 'SET_TASK_ERROR';
export var SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export var SET_ASSIGNEE_USERS = 'SET_ASSIGNEE_USERS';
export var SET_IS_CALL_ENTRY = 'SET_IS_CALL_ENTRY';
/**
 * @description Fetch task list and task dashboard stats
 * @function getTaskList
 * @returns task list, stats and pagination data
 */
export var getTaskList = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var filters, lastEvaluatedKey, params, userId, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: GET_TASK_LIST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                filters = getState().taskManagement.filters;
                lastEvaluatedKey = getState().taskManagement.lastEvaluatedKey;
                params = {
                    sort_order: 'desc',
                    sort_by: 'created_date',
                };
                userId = getState().auth.userId;
                switch (filters.taskScope) {
                    case 'assignedByMe':
                        params.assigned_by = userId;
                        break;
                    case 'assignedToMe':
                        params.assigned_to = userId;
                        break;
                    case 'allTasks':
                        break;
                }
                if (filters.search) {
                    params.search_query = filters.search;
                }
                if (filters.status) {
                    params.status = filters.status;
                }
                if (filters.priority) {
                    params.priority = filters.priority;
                }
                if (filters.role) {
                    params.assigned_to_role = filters.role;
                }
                if (filters.assigneeName) {
                    params.assigned_to_name = filters.assigneeName;
                }
                if (lastEvaluatedKey) {
                    params.last_evaluated_key = lastEvaluatedKey;
                }
                return [4 /*yield*/, getTaskListService(params)];
            case 2:
                response = _a.sent();
                dispatch({
                    type: SET_TASK_LIST,
                    payload: {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    },
                });
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    }];
            case 3:
                error_1 = _a.sent();
                dispatch(setTaskError());
                dispatch(showError(error_1));
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * @description Fetch task dashboard stats
 * @function getTaskStats
 * @returns task stats data
 */
export var getTaskStats = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getTaskStatsService()];
            case 1:
                response = _a.sent();
                dispatch(setTaskStats({
                    open: (response === null || response === void 0 ? void 0 : response.open_tasks) || 0,
                    total: (response === null || response === void 0 ? void 0 : response.total_tasks) || 0,
                    inProgress: (response === null || response === void 0 ? void 0 : response.in_progress_tasks) || 0,
                    completed: (response === null || response === void 0 ? void 0 : response.completed_tasks) || 0,
                }));
                return [2 /*return*/, response];
            case 2:
                error_2 = _a.sent();
                dispatch(showError(error_2));
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var setTaskList = function (payload) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: SET_TASK_LIST,
            payload: payload,
        });
        return [2 /*return*/];
    });
}); }; };
export var setTaskStats = function (payload) { return ({
    type: SET_TASK_STATS,
    payload: payload,
}); };
export var updateTaskFilters = function (key, value) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: SET_TASK_FILTERS,
            payload: {
                key: key,
                value: value,
            },
        });
        return [2 /*return*/];
    });
}); }; };
export var resetTaskManagement = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: RESET_TASK_MANAGEMENT,
        });
        return [2 /*return*/];
    });
}); }; };
export var updatePageNumber = function (value) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: SET_PAGE_NUMBER,
            payload: value,
        });
        return [2 /*return*/];
    });
}); }; };
export var setTaskError = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: SET_TASK_ERROR,
        });
        return [2 /*return*/];
    });
}); }; };
export var setTaskSearchListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: SET_TASK_LIST,
        payload: {
            data: data,
            last_evaluated_key: lastEvaluatedKey,
        },
    });
    dispatch({
        type: SET_PAGE_NUMBER,
        payload: 1,
    });
}; };
/**
 * @description Fetch users by role and store for assignee dropdown
 * @param role
 */
export var getUsersByRole = function (role) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, users, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getUsersByRoleService(role)];
            case 1:
                response = _a.sent();
                users = (response || []).map(function (item) { return ({
                    id: item.user_id,
                    value: item.user_id,
                    name: item.full_name,
                    employeeId: item.employee_id,
                }); });
                dispatch({
                    type: SET_ASSIGNEE_USERS,
                    payload: users,
                });
                return [2 /*return*/, users];
            case 2:
                error_3 = _a.sent();
                throw error_3;
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var setIsCallEntry = function (payload) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: SET_IS_CALL_ENTRY,
            payload: payload,
        });
        return [2 /*return*/];
    });
}); }; };
export var generateTaskCompletionReport = function (fromDate, toDate) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var userName, params, report, attempt, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userName = getState().auth.userName;
                    params = {
                        creator_name: "".concat(userName.first_name, " ").concat(userName.last_name),
                        report_type: API_RESPONSE_REPORT_TYPES.TaskReport,
                        from_date: moment(fromDate).format('YYYY-MM-DD'),
                        to_date: moment(toDate).format('YYYY-MM-DD'),
                        corporation_id: null,
                        corporation_name: 'All Clients',
                        facility_id: 'all_seniors',
                        facility_name: 'All Clients',
                        zone: null,
                        member_type: null,
                    };
                    dispatch(showApplicationLoader('Submitting report request...'));
                    return [4 /*yield*/, postReportService(params)];
                case 1:
                    _b.sent();
                    dispatch(showApplicationLoader('Generating report...'));
                    report = null;
                    attempt = 1;
                    _b.label = 2;
                case 2:
                    if (!(attempt <= 30)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getReportService({
                            report_type: API_RESPONSE_REPORT_TYPES.TaskReport,
                        })];
                case 3:
                    response = _b.sent();
                    report = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a[0];
                    if (report === null || report === void 0 ? void 0 : report.presignedUrl) {
                        return [2 /*return*/, report];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2000); })];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    attempt++;
                    return [3 /*break*/, 2];
                case 6: throw new Error('Report generation timed out.');
            }
        });
    }); };
};
